import { API_URL, ENDPOINTS } from './constants';

const resolveImageUrl = image => {
  if (image.previewUrl) {
    return image.previewUrl;
  }
  if (image.url && image.url.startsWith('http')) {
    return image.url;
  }
  if (typeof image === 'string') {
    return `${API_URL}${ENDPOINTS.PUBLIC_IMAGE(image)}`;
  }
  if (image.filename || image.name) {
    return `${API_URL}${ENDPOINTS.PUBLIC_IMAGE(image.filename || image.name)}`;
  }
  if (image.url && !image.url.startsWith('http')) {
    return `${API_URL}${ENDPOINTS.PUBLIC_IMAGE(image.url)}`;
  }
  return image.url || '';
};

export const getImageUrl = (image, { width } = {}) => {
  const url = resolveImageUrl(image);
  const pixels = Number(width);
  if (!url || !Number.isFinite(pixels) || pixels <= 0) return url;
  if (url.startsWith('blob:') || url.startsWith('data:')) return url;
  if (!url.includes('/files/public-images/')) return url;

  const [base, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  params.set('w', String(Math.round(pixels)));
  return `${base}?${params.toString()}`;
};
